// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slot__container[data-v-2f1fed1d] {\n  width: 223px;\n  height: 40px;\n}\n@media screen and (max-width: 768px) {\n.with-right-border[data-v-2f1fed1d] {\n    border-bottom: 1px solid #e6e6e6;\n    padding-bottom: 5px;\n    border-right: none !important;\n}\n.slot__container[data-v-2f1fed1d] {\n    height: 52px;\n}\n}\n.with-right-border[data-v-2f1fed1d] {\n  border-right: 1px solid #e6e6e6;\n}", ""]);
// Exports
module.exports = exports;
